import * as he from 'he';
import * as React from 'react';
import { RowHeaderTwoProps } from './RowHeaderTwo.props';
import { StyledHeadingTwo, StyledRowHeaderTwo } from './RowHeaderTwo.styles';

export const RowHeaderTwo = ({
  background = 'transparent',
  className = '',
  color = '#fff',
  headingTag = 'h2',
  title,
}: RowHeaderTwoProps) => (
  <StyledRowHeaderTwo className={className} background={background} color={color}>
    <StyledHeadingTwo as={headingTag} color={color} className='displayTitle'>
      {typeof title === 'string' ? he.decode(title) : title}
    </StyledHeadingTwo>
  </StyledRowHeaderTwo>
);
